module.exports = __webpack_public_path__ + "static/media/Inclined-Kids.582b0256.jpg";